// extracted by mini-css-extract-plugin
module.exports = {"container":"home-offer-boxes_container__6lkEx","homeOfferBoxes":"home-offer-boxes_homeOfferBoxes__dVDf_"};